module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_MT-bbd66173ea9937d6733ce08188e85287.svg";